import React from 'react';
import { Avatar, Box, keyframes, useTheme } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export const cycle = keyframes`
  0%, 66%, 100% { opacity: 0.25; }
  33%            { opacity: 1;    }
`;

interface Props {
  avatarSrc?: string;
  avatarName?: string;
  srLabel?: string;
}

const TypingIndicator: React.FC<Props> = ({ avatarSrc, avatarName, srLabel }) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: 1.5, pb: 1 }}
    >
      <Box component="span" sx={visuallyHidden}>{srLabel ?? 'Assistant is typing…'}</Box>
      <Avatar
        src={avatarSrc}
        alt={avatarName}
        aria-hidden="true"
        sx={{ width: 32, height: 32, bgcolor: primaryColor, color: '#fff', flexShrink: 0 }}
      >
        {!avatarSrc && <SmartToyIcon sx={{ fontSize: 18 }} />}
      </Avatar>
      <Box aria-hidden="true" sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        {[0, 0.4, 0.8].map((delay) => (
          <Box
            key={delay}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: primaryColor,
              animation: `${cycle} 1.2s infinite ease-in-out`,
              animationDelay: `${delay}s`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TypingIndicator;
